import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import '../pages/InsightBotPage.css';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw     from 'rehype-raw';


export default function InsightBotPage({ onBack }) {

  const [introText, setIntroText] = useState('');
  const introTextURL = process.env.PUBLIC_URL + '/content/individual_page_intros/InsightBotPage__intro.md';

  useEffect(() => {
    fetch(introTextURL)
      .then(res => res.text())
      .then(setIntroText)
      .catch(console.error);
  }, [introTextURL]);

  return (
    <>
      <Helmet>
        <title>InsightBot | Insight Data LLC</title>
      </Helmet>

      <div className='ib-home-container'>
        <div className='ib-tile-box'>

          <div className='ib-back-button'>
            <button onClick={onBack} className="back-link">
               Back to Projects
            </button>
          </div>

            <h1 style={{ fontSize: '2.5rem', marginBottom: '0.5rem', color: '#222' }}>
              Welcome to InsightBot
            </h1>
            <p style={{ fontSize: '1.125rem', marginBottom: '1.5rem', color: '#444' }}>
              This is the LLM chat backend powering your interactions with InsightDataLLC
            </p>

            <div className='ib-markdown-content'>
              <ReactMarkdown
                style={{ color: '#444' }}
                remarkPlugins={[remarkGfm]}
                rehypePlugins={[rehypeRaw]}
                >
                  {introText}
                </ReactMarkdown>
            </div>

            <div style={{ textAlign: 'right', marginTop: '1rem' }}>
              <a
                href="https://github.com/jakobjgu/dc_public_transport"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#0039A6', fontSize: '0.875rem' }}
              >
                View GitHub Repo
              </a>
            </div>
          </div>

          <div className='ib-image-credit'>
          Background image by alexandra_koch / Pixabay
        </div>
      </div>
    </>
  );
}
